import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ModalRow, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent } from "../../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../../helpers";
import ModalProfileHeader from "../../Common/ModalProfileHeader";

const ViewMoveOutPendingTenantDetail = ({ setViewDetail, selectedData }) => {
    const onClose = () => setViewDetail(false);

    return (
        <Container>
            {/* Header */}
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">View Details</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            {/* Top Section */}
            {/* <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {selectedData?.name}
                    </span>
                    <span className="text-sm text-gray-600">#{selectedData?.roomNum}, {selectedData?.propertyName}</span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className='text-gray-500 text-sm'>{'Rent'}</span>
                    <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.rent}</span>
                </div>
            </ProfileSection> */}

            <ModalProfileHeader
                title="View Details"
                name={capitalizeFirstLetter(selectedData?.name)}
                subtitle={`#${selectedData?.roomNum}, ${selectedData?.propertyName}`}
                amountLabel={"Rent"}
                amount={selectedData?.rent || 0}
                image={selectedData?.profilePicture}
                onClose={onClose}
                showCurrency={true}
            />

            {/* Content */}
            <Content>
                <ScrollableContent>
                    <Wrapper>
                        {/* Basic Information */}
                        <BtnWrapper>
                            <ModalSectionTitle>Basic Information</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Mobile</LabelShow>
                                    <ModalRowValue>#{selectedData?.mobile}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Occupation</LabelShow>
                                    <ModalRowValue>{selectedData?.occupation}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Gender</LabelShow>
                                    <LabelShow>{selectedData?.gender === 1 ? 'Male' : selectedData?.gender === 2 ? 'Female' : 'Other'}</LabelShow>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Floor/Flat</LabelShow>
                                    <ModalRowValue>{selectedData?.flatName}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>KYC Status</LabelShow>
                                    <ModalRowValue className={(selectedData?.kycStatus === 5 || selectedData?.kycStatus === 4) ? 'text-green-600' : 'text-amber-600'}>
                                        {(selectedData?.kycStatus === 5 || selectedData?.kycStatus === 4) ? 'Verified' : 'Pending'}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Police Verified</LabelShow>
                                    <ModalRowValue className={selectedData?.isPoliceVerified === 1 ? 'text-green-600' : 'text-red-600'}>
                                        {selectedData?.isPoliceVerified === 1 ? 'Yes' : 'No'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>

                        {/* Agreement Details */}
                        <BtnWrapper>
                            <ModalSectionTitle>Agreement Details</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Agreement Period</LabelShow>
                                    <ModalRowValue>{selectedData?.agreementPeriod || '0'} months</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Agreement Start Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.agreementStartDate
                                            ? moment(selectedData?.agreementStartDate).format("DD MMM YYYY")
                                            : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>

                                <FlexCol>
                                    <LabelShow>Move-in Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.moveInDate
                                            ? moment(selectedData?.moveInDate).format("DD MMM YYYY")
                                            : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Moving-out Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.moveOutDate
                                            ? moment(selectedData?.moveOutDate).format("DD MMM YYYY")
                                            : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>

                                <FlexCol>
                                    <LabelShow>Rent Agreement Signed</LabelShow>
                                    <ModalRowValue className={selectedData?.isRentAgreementSigned === 1 ? 'text-green-600' : 'text-red-600'}>
                                        {selectedData?.isRentAgreementSigned === 1 ? 'Yes' : 'No'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>

                        {/* Financial Details */}
                        <BtnWrapper>
                            <ModalSectionTitle>Financial Details</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Monthly Rent</LabelShow>
                                    <ModalRowValue>₹{selectedData?.rent}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Security Deposit</LabelShow>
                                    <ModalRowValue>₹{selectedData?.security || '0'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Booking Amount</LabelShow>
                                    <ModalRowValue>₹{selectedData?.bookingAmt || '0'}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <LabelShow>Total Dues</LabelShow>
                                    <ModalRowValue className="text-red-600 font-semibold">₹{selectedData?.totalDues || '0'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <LabelShow>Due Date</LabelShow>
                                    <ModalRowValue>
                                        {selectedData?.dueDate
                                            ? moment(selectedData?.dueDate).format("DD MMM YYYY")
                                            : 'Not set'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

export default ViewMoveOutPendingTenantDetail;

// ---------------- Styled Components ----------------
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const LabelShow = tw.label`text-sm text-gray-400 font-normal`;